import { createContext } from 'react';
var context = {
  careInstructions: null,
  colorway: null,
  fabric: null,
  fitRatingAvg: null,
  reviewCount: null,
  setShowAskQuestion: null,
  showAskQuestion: false
};
export var ProductContext = /*#__PURE__*/createContext(context);